import { formatMCapAndEVCell } from "src/app/utils/common";
import {
  Component,
  Input,
  SimpleChanges,
  ViewChild,
  Output,
  TemplateRef,
  EventEmitter,
} from "@angular/core";
import { CompsTable, CompsTableRow } from "../comps-page.model";
import { MatTable } from "@angular/material/table";
import { MatMenuTrigger } from "@angular/material/menu";
import { faSortUp, faSortDown } from "@fortawesome/free-solid-svg-icons";
import { NzMessageService } from "ng-zorro-antd/message";
import { Dictionary } from "highcharts/highcharts.src";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { AppState } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import {
  SetDpParams,
  SetAuditCallFbar,
  DeleteDpParams,
} from "src/app/store/actions/global-subheader.actions";
import { ActivatedRoute } from "@angular/router";
import { AppService } from "src/app/app.service";
import { CompsDataService } from "../comps-data.service";
import { getYoy } from "src/app/comps-page/utils";
import {
  ABS_PERIOD_TYPE,
  CY_PERIOD_BASIS,
} from "@va/core-library/period-filter";
import { VAIconRegistryService, close } from "@va/core-library/icons";
@Component({
  selector: "app-comps-grid",
  templateUrl: "./comps-grid.component.html",
  styleUrls: ["./comps-grid.component.scss"],
})
export class CompsGridComponent {
  @Input() metaReady: boolean;
  @Input() dataReady: boolean;
  @Input() compsTableData: CompsTable = {
    rows: [],
    columns: [],
    marketColumns: [],
    columnData: {},
    filter: {},
    rowData: {},
    extras: {},
    title: "",
  };
  @Input() isTimeSeries: boolean;
  @Input() hasFuzzyPanel: boolean;
  @Input() hasUnsavedData: boolean;
  @Input() fuzzySwitch: boolean;
  @Input() hasContextMenu: boolean;
  @Input() hasFormulaBar: boolean;
  @Input() maxHeight: number;
  @Input() tableClassName: string;
  @Input() isIndustryPage = false;
  @Input() allowTickerDeletion = true;
  @Input() showCompanyCount = false;
  @Input() showBlankTickers = false;
  @Input() sortByColumnId = "";
  @Input() selectedLineCell = "";
  @Input() resetSortonDataReady: boolean = false;
  @Output() onCellClick: EventEmitter<any> = new EventEmitter();
  @Output() onDeleteTicker: EventEmitter<any> = new EventEmitter();
  // @Output() onChangeTicker: EventEmitter<any> = new EventEmitter();
  @Output() onShowChart: EventEmitter<{
    item: Dictionary<any>;
    chartType: string;
  }> = new EventEmitter();

  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild(MatMenuTrigger) contextMenu: MatMenuTrigger;
  @ViewChild("successTemplate") successTemplate: TemplateRef<any>;
  contextMenuPosition = { x: "0px", y: "0px" };
  compsTableDataRowsDefaultOrer: Array<CompsTableRow>;
  staticDisplayColumns = ["ticker", "company", "yearend"];
  displayColumns;
  tableWidth = 370;
  selectedTicker = "";
  sortDirection = "";
  activeSort = "";
  snackbarMessage = "";
  faSortUp = faSortUp;
  faSortDown = faSortDown;
  selectedPeriod: string;
  showValue: boolean;
  showYoy: boolean;
  showRevision: boolean;
  showMedian: boolean;
  showAverage: boolean;
  showTotal: boolean;
  lineHasTotal: boolean;
  revision: string;
  source: string;
  currency: string;
  // tickerDelete = false;
  lineHasPeersMapping = {};
  contextMenuReady = false;
  snackBarRef: MatSnackBarRef<any>;
  currentAbsCalendarYear = `CY-${new Date().getFullYear()}`;
  currentAbsFiscalYear = `FY-${new Date().getFullYear()}`;
  marketColumns = [];

  originalCompsTableData: CompsTable;

  constructor(
    private message: NzMessageService,
    private snackBar: MatSnackBar,
    private store: Store<AppState>,
    private appService: AppService,
    protected route: ActivatedRoute,
    private dataService: CompsDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([close]);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.compsTableData && changes.compsTableData.currentValue) {
      this.compsTableData = changes.compsTableData.currentValue;
      const dataColumnKeys = this.compsTableData.columns;
      this.marketColumns = this.compsTableData.marketColumns || [];
      this.selectedPeriod = this.compsTableData.filter.selectedPeriod;
      this.showValue = this.compsTableData.filter.showValue;
      this.showYoy = this.compsTableData.filter.showYoy;
      this.showRevision = this.compsTableData.filter.showRevision;
      this.showMedian = this.compsTableData.filter.showMedian;
      this.showAverage = this.compsTableData.filter.showAverage;
      this.showTotal = this.compsTableData.filter.showTotal;
      this.lineHasTotal = this.compsTableData.filter.lineHasTotal;
      this.source = this.compsTableData.filter.source;
      this.currency = this.compsTableData.filter.currency;
      this.revision = this.compsTableData.filter.revision;
      this.displayColumns = [...this.staticDisplayColumns];

      const marketColumnsLength = this.marketColumns.length;
      if (this.showValue && this.showYoy) {
        this.displayColumns.push("datatype");
        this.tableWidth =
          420 + (dataColumnKeys.length + marketColumnsLength) * 136 + 100;
      } else {
        this.tableWidth =
          370 + (dataColumnKeys.length + marketColumnsLength) * 136 + 100;
      }
      this.marketColumns.forEach((item) => {
        this.displayColumns.push(`${item.id}`);
      });
      dataColumnKeys.forEach((colKey) => {
        this.displayColumns.push(`${colKey}`);
      });
      this.compsTableDataRowsDefaultOrer = JSON.parse(
        JSON.stringify(this.compsTableData.rows),
      );
      this.selectedLineCell = "";
    }
    if (
      ((changes.dataReady && changes.dataReady.currentValue === true) ||
        (changes.showBlankTickers &&
          changes.showBlankTickers.currentValue !==
            changes.showBlankTickers.previousValue)) &&
      this.resetSortonDataReady
    ) {
      this.activeSort = "";
    }

    if (
      (changes.dataReady && changes.dataReady.currentValue === true) ||
      (changes.showBlankTickers &&
        changes.showBlankTickers.currentValue !==
          changes.showBlankTickers.previousValue)
    ) {
      if (this.isIndustryPage && this.compsTableData && this.sortByColumnId) {
        if (!this.sortDirection) {
          this.sortDirection = "desc";
        }
        const existingActiveSortExists = this.compsTableData.columns.includes(
          this.activeSort,
        );

        if (!existingActiveSortExists) {
          this.sortData(this.sortByColumnId, this.sortDirection);
        }
      }
      if (this.showAverage) {
        this.computeAverages();
      }
      if (this.showMedian) {
        this.computeMedians();
      }
      // if (this.showTotal) {
      //   this.computeTotal();
      // }
      if (this.showCompanyCount) {
        this.computeCompanyCount();
      }
      this.store.dispatch(new DeleteDpParams());
      this.selectedLineCell = "";
      this.selectedTicker = "";
    } else {
      if (this.compsTableData && this.compsTableData.extras.recomputeData) {
        if (this.showAverage) {
          this.computeAverages();
        }
        if (this.showMedian) {
          this.computeMedians();
        }
        // if (this.showTotal) {
        //   this.computeTotal();
        // }
        if (this.showCompanyCount) {
          this.computeCompanyCount();
        }
      }
      this.store.dispatch(new DeleteDpParams());
      this.selectedLineCell = "";
      this.selectedTicker = "";
    }
  }

  cellContextMenu(
    event: MouseEvent,
    row: CompsTableRow,
    colKey: number,
    valueType: string,
  ): void {
    if (!this.hasContextMenu) {
      event.preventDefault();
      return;
    }
    const isMarketKey = this.checkIfMarketKey(colKey);
    if (
      this.lineHasPeersMapping[
        `${row.ticker}_${this.compsTableData.columnData[colKey].sliId}`
      ] === undefined &&
      !isMarketKey
    ) {
      this.contextMenuReady = false;
      this.showContextMenu(event, row, colKey, valueType);
      //api
      this.dataService
        .getCompanyPeers(
          [row.ticker],
          [this.compsTableData.columnData[colKey].sliId],
          1,
          true,
        )
        .subscribe((resp) => {
          if (resp.status !== "error") {
            this.lineHasPeersMapping[
              `${row.ticker}_${this.compsTableData.columnData[colKey].sliId}`
            ] = resp.peer_info && resp.peer_info.length ? true : false;
          }
          this.contextMenu.menuData.item.showPeerOptions =
            this.lineHasPeersMapping[
              `${row.ticker}_${this.compsTableData.columnData[colKey].sliId}`
            ] &&
            (this.source === "Consensus" ||
              this.source === "VA Actuals/Consensus" ||
              this.source === "VA Actuals");
          this.contextMenuReady = true;
        });
    } else {
      this.contextMenuReady = true;
      this.showContextMenu(event, row, colKey, valueType);
    }
  }

  showContextMenu(
    event: MouseEvent,
    row: CompsTableRow,
    colKey: number,
    valueType: string,
  ) {
    if (!this.compsTableData.rowData[row.ticker]) {
      return;
    }
    const isMarketKey = this.checkIfMarketKey(colKey);
    if (isMarketKey) {
      if (
        this.compsTableData.rowData[row.ticker] &&
        this.compsTableData.rowData[row.ticker].market_data &&
        this.compsTableData.rowData[row.ticker].market_data[colKey][valueType]
      ) {
        event.preventDefault();
        this.selectedTicker = row.ticker;
        this.onMarketLineCellClick(row.ticker, colKey, valueType, undefined);
        this.contextMenuPosition.x = `${event.clientX}px`;
        this.contextMenuPosition.y = `${event.clientY}px`;
        this.contextMenu.menuData = {
          item: {
            row: row,
            colKey: colKey,
            dapParamId: colKey,
            showChartOptions: false,
            showPeerOptions: false,
            showPeerRevision: false,
            showSurprise: false,
            showRevision: false,
            showDistribution: false,
          },
        };
        this.contextMenu.menu.focusFirstItem("mouse");
        this.contextMenu.openMenu();
      } else {
        this.contextMenu.closeMenu();
        this.selectedLineCell = "";
      }
    } else {
      const sliData = this.isTimeSeries
        ? this.compsTableData.rowData[row.ticker][
            this.compsTableData.columnData[colKey].sliCompsId
          ]
        : this.compsTableData.rowData[row.ticker][colKey];
      const period = this.isTimeSeries ? colKey : this.selectedPeriod;
      if (
        sliData &&
        sliData[period] &&
        sliData[period][valueType] !== undefined &&
        sliData[period][valueType] !== null
      ) {
        event.preventDefault();
        this.selectedTicker = row.ticker;
        this.onLineCellClick(row.ticker, colKey, valueType, undefined);
        this.contextMenuPosition.x = `${event.clientX}px`;
        this.contextMenuPosition.y = `${event.clientY}px`;
        const sliCompsId = this.isTimeSeries
          ? this.compsTableData.columnData[colKey].sliCompsId
          : colKey;
        const contextMenuOptions: Dictionary<Set<string>> =
          this.getContextMenuOptions(
            sliCompsId,
            period as string,
            this.compsTableData.rowData[row.ticker][sliCompsId][period]
              .is_forecast,
          );
        this.contextMenu.menuData = {
          item: {
            row: row,
            colKey: colKey,
            period: period,
            isValuationRatio:
              this.compsTableData.columnData[colKey].isValuationRatio,
            dapParamId: this.compsTableData.columnData[colKey].sliId,
            showChartOptions: contextMenuOptions["chartOptionsToShow"].size > 0,
            showTrend: contextMenuOptions["chartOptionsToShow"].has("trend"),
            showPeerOptions:
              contextMenuOptions["vsPeersOptionsToShow"].size > 0 &&
              this.lineHasPeersMapping[
                `${row.ticker}_${this.compsTableData.columnData[colKey].sliId}`
              ] &&
              (this.source === "Consensus" ||
                this.source === "VA Actuals/Consensus" ||
                this.source === "VA Actuals"),
            showPeerTrend:
              contextMenuOptions["vsPeersOptionsToShow"].has("trend"),
            showPeerRevision:
              contextMenuOptions["vsPeersOptionsToShow"].has("revision") &&
              (this.source === "Consensus" ||
                (this.source === "VA Actuals/Consensus" &&
                  this.compsTableData.rowData[row.ticker][sliCompsId][period]
                    .is_forecast)),
            showSurprise:
              contextMenuOptions["chartOptionsToShow"].has("surprise") &&
              (this.compsTableData.rowData[row.ticker][sliCompsId][period]
                .is_forecast === false &&
              this.source.toLowerCase() !== "consensus+"
                ? true
                : false),
            showRevision:
              contextMenuOptions["chartOptionsToShow"].has("revision") &&
              (this.source === "Filings" ||
              this.source.toLowerCase() === "consensus+"
                ? false
                : true),
            showDistribution:
              contextMenuOptions["chartOptionsToShow"].has("distribution") &&
              (this.source === "Consensus" ||
              (this.source === "VA Actuals/Consensus" &&
                this.compsTableData.rowData[row.ticker][sliCompsId][period]
                  .is_forecast === true)
                ? true
                : false),
          },
        };
        this.contextMenu.menu.focusFirstItem("mouse");
        this.contextMenu.openMenu();
      } else {
        this.contextMenu.closeMenu();
        this.selectedLineCell = "";
      }
    }
  }

  getContextMenuOptions(
    sliCompsId: number,
    period: string,
    isForecast: boolean,
  ): Dictionary<Set<string>> {
    const chartOptionsToShow: Set<string> = new Set();
    const vsPeersOptionsToShow: Set<string> = new Set();

    if (sliCompsId === 10 || sliCompsId === 11 || sliCompsId === 34) {
      return {
        chartOptionsToShow: chartOptionsToShow,
        vsPeersOptionsToShow: vsPeersOptionsToShow,
      };
    }

    const colKey = this.isTimeSeries ? period : sliCompsId;

    //Not regular line means this is valuatoin ratio
    if (this.compsTableData.columnData[colKey].isValuationRatio === true) {
      chartOptionsToShow.add("revision");

      if (!["NTM", "LTM", "STM"].includes(period)) {
        chartOptionsToShow.add("trend");
        vsPeersOptionsToShow.add("trend");
      }

      if (this.source === "VA Actuals/Consensus" && isForecast) {
        vsPeersOptionsToShow.add("revision");
      }
    } else {
      if (period === "LTM" || period === "NTM" || period === "STM") {
        chartOptionsToShow.add("revision");
        vsPeersOptionsToShow.add("revision");
      } else if (this.compsTableData.filter.basisType === CY_PERIOD_BASIS.id) {
        chartOptionsToShow.add("trend");
        chartOptionsToShow.add("revision");

        vsPeersOptionsToShow.add("trend");
        vsPeersOptionsToShow.add("revision");
      } else {
        if (this.compsTableData.filter.periodType !== ABS_PERIOD_TYPE.id) {
          chartOptionsToShow.add("trend");
          chartOptionsToShow.add("revision");

          vsPeersOptionsToShow.add("trend");
          vsPeersOptionsToShow.add("revision");
        } else {
          chartOptionsToShow.add("trend");
          chartOptionsToShow.add("revision");
          if (isForecast) {
            chartOptionsToShow.add("distribution");
          } else {
            chartOptionsToShow.add("surprise");
          }

          vsPeersOptionsToShow.add("trend");
          vsPeersOptionsToShow.add("revision");
        }
      }
    }

    return {
      chartOptionsToShow: chartOptionsToShow,
      vsPeersOptionsToShow: vsPeersOptionsToShow,
    };
  }

  onRowClick(rowObj: CompsTableRow) {
    this.selectedTicker = rowObj.ticker;
    this.selectedLineCell = "";
  }

  onLineCellClick(ticker, colKey, valueType: string, event) {
    const sliCompsData = this.isTimeSeries
      ? this.compsTableData.rowData[ticker][
          this.compsTableData.columnData[colKey].sliCompsId
        ]
      : this.compsTableData.rowData[ticker][colKey];
    this.selectedTicker = ticker;
    const period = this.isTimeSeries ? colKey : this.selectedPeriod;
    if (
      sliCompsData &&
      sliCompsData[period] &&
      sliCompsData[period][valueType] !== undefined &&
      sliCompsData[period][valueType] !== null
    ) {
      //process dpParam call only if its a new data cell selection
      if (
        this.hasFormulaBar &&
        this.selectedLineCell !== `${ticker}_${valueType}_${colKey}`
      ) {
        this.onCellClick.emit();
        const today = new Date();
        const mm = today.getMonth() + 1;
        const dd = today.getDate();
        const yyyy = today.getFullYear();

        const sliCompsId = this.isTimeSeries
          ? this.compsTableData.columnData[colKey].sliCompsId
          : colKey;
        const dpParams = {
          dp: `${
            this.compsTableData.rowData[ticker][`${sliCompsId}|RD`][period][
              valueType
            ]
          }|${mm}/${dd}/${yyyy}`, //"16151916582|09/02/2020",
          cut: "STD",
          ticker: ticker,
          // source: this.source.toLowerCase(),
          growthType: valueType === "values" ? "Analytics" : "YoY%",
          shouldLog: true,
          revision: "",
          period: period,
          extras: `${
            this.compsTableData.rowData[ticker][`${sliCompsId}|RD`][period][
              valueType
            ]
          }|${period}`, //"16151916582|CY-2020"
        };
        if (this.source === "VA Actuals/Consensus") {
          if (
            this.compsTableData.rowData[ticker][sliCompsId][period]
              .is_forecast === false
          ) {
            dpParams["source"] = "va actuals";
          } else {
            dpParams["source"] = "consensus";
          }
        } else {
          dpParams["source"] = `${encodeURIComponent(
            this.source.toLowerCase(),
          )}`;
        }

        if (dpParams.growthType === "YoY%") {
          dpParams["historical_focus"] = "VA Actuals";
        }
        if (this.compsTableData.columnData[colKey].isFuzzy) {
          dpParams["enable_fuzzy"] = true;
        }
        if (this.currency !== "Base") {
          dpParams["currency"] = this.currency;
        }
        this.store.dispatch(new SetDpParams(dpParams));
      }
      this.selectedLineCell = `${ticker}_${valueType}_${colKey}`;
    } else {
      //there is no data
      this.selectedLineCell = "";
      this.store.dispatch(new DeleteDpParams());
    }
    if (event) {
      event.stopPropagation(); // prevent onRowClick
    }
  }

  onMarketLineCellClick(ticker, colKey, valueType: string, event) {
    const data = this.compsTableData.rowData[ticker].market_data[colKey];
    const valueExist = data && typeof data[valueType] === "number";

    this.selectedTicker = ticker;

    if (valueExist) {
      //process dpParam call only if its a new data cell selection
      if (
        this.hasFormulaBar &&
        this.selectedLineCell !== `${ticker}_${valueType}_${colKey}`
      ) {
        this.onCellClick.emit();
        const today = new Date();
        const mm = today.getMonth() + 1;
        const dd = today.getDate();
        const yyyy = today.getFullYear();
        const period = `CY-${yyyy}`;

        const dpParams = {
          dp: `${data.rd[valueType]}|${mm}/${dd}/${yyyy}`, //"16151916582|09/02/2020",
          cut: "STD",
          ticker: ticker,
          // source: this.source.toLowerCase(),
          growthType: valueType === "values" ? "Analytics" : "YoY%",
          shouldLog: true,
          revision: "",
          period,
          extras: `${data.rd[valueType]}|${period}`, //"16151916582|CY-2020"
          isUniversalsliid: true,
        };
        if (this.source === "VA Actuals/Consensus") {
          dpParams["source"] = "consensus";
        } else {
          dpParams["source"] = `${encodeURIComponent(
            this.source.toLowerCase(),
          )}`;
        }

        if (dpParams.growthType === "YoY%") {
          dpParams["historical_focus"] = "VA Actuals";
        }
        if (this.compsTableData.columnData[colKey].isFuzzy) {
          dpParams["enable_fuzzy"] = true;
        }
        if (this.currency !== "Base") {
          dpParams["currency"] = this.currency;
        }
        this.store.dispatch(new SetDpParams(dpParams));
      }
      this.selectedLineCell = `${ticker}_${valueType}_${colKey}`;
    } else {
      //there is no data
      this.selectedLineCell = "";
      this.store.dispatch(new DeleteDpParams());
    }
    if (event) {
      event.stopPropagation(); // prevent onRowClick
    }
  }

  formatCell(data, currency, colSliCompId, valueType: string) {
    const sliCompsData = data;
    if (sliCompsData === undefined || sliCompsData === null) {
      return "-";
    }

    const valueToUse = new Intl.NumberFormat("en-US", {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(Math.abs(sliCompsData));
    let unitType = this.compsTableData.columnData[colSliCompId].unit;
    if (!currency || valueType === "yoy" || valueType === "revision") {
      currency = "";
    }
    if (unitType === "%") {
      unitType = valueType === "yoy" || valueType === "revision" ? "bps" : "%";
    } else {
      unitType = valueType === "yoy" || valueType === "revision" ? "%" : "";
    }
    if (sliCompsData < 0) {
      return `(${currency}${valueToUse}${unitType})`;
    }
    return `${currency}${valueToUse}${unitType}`;
  }

  sortData(colKey, sortDirection = "") {
    if (sortDirection) {
      this.sortDirection = sortDirection;
    } else {
      if (colKey === this.activeSort) {
        this.sortDirection =
          this.sortDirection === ""
            ? "asc"
            : this.sortDirection === "asc"
              ? "desc"
              : "";
      } else {
        this.sortDirection = "asc";
      }
    }
    this.activeSort = colKey;
    switch (colKey) {
      case "company":
        if (this.sortDirection === "") {
          this.compsTableData.rows = [...this.compsTableDataRowsDefaultOrer];
          this.activeSort = "";
        } else {
          this.compsTableData.rows.sort((a, b) => {
            if (this.sortDirection === "asc") {
              return a.full_name.localeCompare(b.full_name);
            }

            return b.full_name.localeCompare(a.full_name);
          });
        }
        this.table.renderRows();
        break;
      case "period":
        if (this.sortDirection === "") {
          this.compsTableData.rows = [...this.compsTableDataRowsDefaultOrer];
          this.activeSort = "";
        } else {
          this.compsTableData.rows.sort((a, b) => {
            const firstValue =
              (this.compsTableData.rowData[a.ticker] &&
                this.compsTableData.rowData[a.ticker].relative_period_Y1) ||
              "";
            const secondValue =
              (this.compsTableData.rowData[b.ticker] &&
                this.compsTableData.rowData[b.ticker].relative_period_Y1) ||
              "";
            if (this.sortDirection === "asc") {
              return firstValue.localeCompare(secondValue);
            }

            return secondValue.localeCompare(firstValue);
          });
        }
        this.table.renderRows();
        break;
      default:
        //sort for data columns
        if (this.sortDirection === "") {
          this.compsTableData.rows = [...this.compsTableDataRowsDefaultOrer];
          this.activeSort = "";
        } else {
          const sortKey =
            this.showValue && this.showYoy
              ? "values"
              : this.showValue
                ? "values"
                : this.showYoy
                  ? "yoy"
                  : this.showRevision
                    ? "revision"
                    : "values";
          const isMarketKey = this.checkIfMarketKey(colKey);
          const period = this.isTimeSeries ? colKey : this.selectedPeriod;
          this.compsTableData.rows.sort((a, b) => {
            let aSliData = null;
            let bSliData = null;
            if (isMarketKey) {
              aSliData =
                this.compsTableData.rowData[a.ticker] &&
                this.compsTableData.rowData[a.ticker].market_data &&
                this.compsTableData.rowData[a.ticker].market_data[colKey] &&
                this.compsTableData.rowData[a.ticker].market_data[colKey][
                  sortKey
                ] !== undefined &&
                this.compsTableData.rowData[a.ticker].market_data[colKey][
                  sortKey
                ] !== null
                  ? this.compsTableData.rowData[a.ticker].market_data[colKey][
                      sortKey
                    ]
                  : -99999;
              bSliData =
                this.compsTableData.rowData[b.ticker] &&
                this.compsTableData.rowData[b.ticker].market_data &&
                this.compsTableData.rowData[b.ticker].market_data[colKey] &&
                this.compsTableData.rowData[b.ticker].market_data[colKey][
                  sortKey
                ] !== undefined &&
                this.compsTableData.rowData[b.ticker].market_data[colKey][
                  sortKey
                ] !== null
                  ? this.compsTableData.rowData[b.ticker].market_data[colKey][
                      sortKey
                    ]
                  : -99999;
            } else {
              aSliData = this.isTimeSeries
                ? this.compsTableData.rowData[a.ticker] &&
                  this.compsTableData.rowData[a.ticker][
                    this.compsTableData.columnData[colKey].sliCompsId
                  ]
                : this.compsTableData.rowData[a.ticker] &&
                  this.compsTableData.rowData[a.ticker][colKey];
              aSliData =
                aSliData &&
                aSliData[period] &&
                aSliData[period][sortKey] !== undefined
                  ? aSliData[period][sortKey]
                  : -99999;
              bSliData = this.isTimeSeries
                ? this.compsTableData.rowData[b.ticker] &&
                  this.compsTableData.rowData[b.ticker][
                    this.compsTableData.columnData[colKey].sliCompsId
                  ]
                : this.compsTableData.rowData[b.ticker] &&
                  this.compsTableData.rowData[b.ticker][colKey];
              bSliData =
                bSliData &&
                bSliData[period] &&
                bSliData[period][sortKey] !== undefined
                  ? bSliData[period][sortKey]
                  : -99999;
            }

            if (this.sortDirection === "asc") {
              if (aSliData === undefined && bSliData === undefined) {
                return 1;
              }
              if (aSliData === undefined) {
                return -1;
              }
              if (bSliData === undefined) {
                return 1;
              }
              if (aSliData === "NM" && bSliData === "NM") {
                return 1;
              }
              if (aSliData === "NM") {
                return -1;
              }
              if (bSliData === "NM") {
                return 1;
              }
              return aSliData - bSliData;
            }
            if (aSliData === undefined) {
              return 1;
            }
            if (bSliData === undefined) {
              return -1;
            }
            if (aSliData === "NM") {
              return 1;
            }
            if (bSliData === "NM") {
              return -1;
            }
            return bSliData - aSliData;
          });
        }
        this.table && this.table.renderRows();
        break;
    }
  }

  computeAverages() {
    const viewBy = [];
    if (this.showValue) {
      viewBy.push("values");
    }
    if (this.showYoy) {
      viewBy.push("yoy");
    }
    if (this.showRevision) {
      viewBy.push("revision");
    }

    const valueRawFormattedMapping = {
      values: "formattedValue",
      yoy: "formattedYoy",
      revision: "formattedRevision",
    };
    // market Columns calculation
    if (
      this.compsTableData.marketColumns &&
      this.compsTableData.marketColumns.length
    ) {
      this.compsTableData.marketColumns.forEach((item) => {
        const id = item.id;
        viewBy.forEach((valueType) => {
          if (id === 10 || this.currency === "Base") {
            this.compsTableData.columnData[id].average = {};
          } else {
            const values: Array<number> = [];
            let currencySymbol = "";
            this.compsTableData.rows.forEach((row) => {
              if (
                this.compsTableData.rowData[row.ticker] &&
                this.compsTableData.rowData[row.ticker].market_data &&
                this.compsTableData.rowData[row.ticker].market_data[id] &&
                this.compsTableData.rowData[row.ticker].market_data[id][
                  valueType
                ] !== undefined &&
                this.compsTableData.rowData[row.ticker].market_data[id][
                  valueType
                ] !== "NM"
              ) {
                values.push(
                  this.compsTableData.rowData[row.ticker].market_data[id][
                    valueType
                  ],
                );
                currencySymbol =
                  this.compsTableData.rowData[row.ticker].market_data[id]
                    .currencySymbol;
              }
            });

            if (values.length) {
              const summation = values.reduce((sum, val) => sum + val);
              const avg = summation / values.length;
              this.compsTableData.columnData[id].average[valueType] = avg;
              this.compsTableData.columnData[id].average["currencySymbol"] =
                currencySymbol;

              const formattedVal = formatMCapAndEVCell(
                avg,
                currencySymbol || "",
                valueType,
              );
              this.compsTableData.columnData[id].average[
                valueRawFormattedMapping[valueType]
              ] = formattedVal;
            } else {
              this.compsTableData.columnData[id].average[valueType] = null;
              this.compsTableData.columnData[id].average[
                valueRawFormattedMapping[valueType]
              ] = null;
            }
          }
        });
      });
    }

    // period/line Columns calculation
    this.compsTableData.columns.forEach((colKey) => {
      const colSliId = this.isTimeSeries
        ? this.compsTableData.columnData[colKey].sliCompsId
        : colKey;
      const period = this.isTimeSeries ? colKey : this.selectedPeriod;
      viewBy.forEach((valueType) => {
        if (
          this.currency === "Base" &&
          this.compsTableData.columnData[colKey].unit === "Amount"
        ) {
          this.compsTableData.columnData[colKey].average = {};
        } else {
          const values: Array<number> = [];
          let currency = "";
          this.compsTableData.rows.forEach((row) => {
            if (
              this.compsTableData.rowData[row.ticker] &&
              this.compsTableData.rowData[row.ticker][colSliId] &&
              this.compsTableData.rowData[row.ticker][colSliId][period] &&
              this.compsTableData.rowData[row.ticker][colSliId][period][
                valueType
              ] !== undefined &&
              this.compsTableData.rowData[row.ticker][colSliId][period][
                valueType
              ] !== "NM" &&
              (this.showBlankTickers ||
                (!this.showBlankTickers &&
                  this.compsTableData.rowData[row.ticker][
                    `${colSliId}|data_exists`
                  ]))
            ) {
              values.push(
                this.compsTableData.rowData[row.ticker][colSliId][period][
                  valueType
                ],
              );
              currency =
                this.compsTableData.rowData[row.ticker][`${colSliId}|C`];
            }
          });
          if (values.length) {
            const summation = values.reduce((sum, val) => sum + val);
            const avg = summation / values.length;
            this.compsTableData.columnData[colKey].average[valueType] = avg;
            this.compsTableData.columnData[colKey].average["currency"] =
              currency;
          } else {
            this.compsTableData.columnData[colKey].average[valueType] = null;
          }
        }
      });
    });
  }

  computeMedians() {
    const viewBy = [];
    if (this.showValue) {
      viewBy.push("values");
    }
    if (this.showYoy) {
      viewBy.push("yoy");
    }
    if (this.showRevision) {
      viewBy.push("revision");
    }
    const valueRawFormattedMapping = {
      values: "formattedValue",
      yoy: "formattedYoy",
      revision: "formattedRevision",
    };
    // market Columns calculation
    if (
      this.compsTableData.marketColumns &&
      this.compsTableData.marketColumns.length
    ) {
      this.compsTableData.marketColumns.forEach((item) => {
        const id = item.id;
        viewBy.forEach((valueType) => {
          if (id === 10 || this.currency === "Base") {
            this.compsTableData.columnData[id].median = {};
          } else {
            const values: Array<number> = [];
            let currencySymbol = "";
            this.compsTableData.rows.forEach((row) => {
              if (
                this.compsTableData.rowData[row.ticker] &&
                this.compsTableData.rowData[row.ticker].market_data &&
                this.compsTableData.rowData[row.ticker].market_data[id] &&
                this.compsTableData.rowData[row.ticker].market_data[id][
                  valueType
                ] !== undefined &&
                this.compsTableData.rowData[row.ticker].market_data[id][
                  valueType
                ] !== "NM"
              ) {
                values.push(
                  this.compsTableData.rowData[row.ticker].market_data[id][
                    valueType
                  ],
                );
                currencySymbol =
                  this.compsTableData.rowData[row.ticker].market_data[id]
                    .currencySymbol;
              }
            });
            if (values.length) {
              const sortedValues = values.sort((a, b) => a - b);
              const lowMiddle = Math.floor((sortedValues.length - 1) / 2);
              const highMiddle = Math.ceil((sortedValues.length - 1) / 2);
              const median =
                (sortedValues[lowMiddle] + sortedValues[highMiddle]) / 2;
              this.compsTableData.columnData[id].median[valueType] = median;
              this.compsTableData.columnData[id].median["currencySymbol"] =
                currencySymbol;
              const formattedVal = formatMCapAndEVCell(
                median,
                currencySymbol || "",
                valueType,
              );
              this.compsTableData.columnData[id].median[
                valueRawFormattedMapping[valueType]
              ] = formattedVal;
            } else {
              this.compsTableData.columnData[id].median[valueType] = null;
              this.compsTableData.columnData[id].median[
                valueRawFormattedMapping[valueType]
              ] = null;
            }
          }
        });
      });
    }

    // period/line Columns calculation
    this.compsTableData.columns.forEach((colKey) => {
      const colSliId = this.isTimeSeries
        ? this.compsTableData.columnData[colKey].sliCompsId
        : colKey;
      const period = this.isTimeSeries ? colKey : this.selectedPeriod;
      viewBy.forEach((valueType) => {
        if (
          this.currency === "Base" &&
          this.compsTableData.columnData[colKey].unit === "Amount"
        ) {
          this.compsTableData.columnData[colKey].median = {};
        } else {
          const values: Array<number> = [];
          let currency = "";
          this.compsTableData.rows.forEach((row) => {
            if (
              this.compsTableData.rowData[row.ticker] &&
              this.compsTableData.rowData[row.ticker][colSliId] &&
              this.compsTableData.rowData[row.ticker][colSliId][period] &&
              this.compsTableData.rowData[row.ticker][colSliId][period][
                valueType
              ] !== undefined &&
              this.compsTableData.rowData[row.ticker][colSliId][period][
                valueType
              ] !== "NM" &&
              (this.showBlankTickers ||
                (!this.showBlankTickers &&
                  this.compsTableData.rowData[row.ticker][
                    `${colSliId}|data_exists`
                  ]))
            ) {
              values.push(
                this.compsTableData.rowData[row.ticker][colSliId][period][
                  valueType
                ],
              );
              currency =
                this.compsTableData.rowData[row.ticker][`${colSliId}|C`];
            }
          });
          if (values.length) {
            const sortedValues = values.sort((a, b) => a - b);
            const lowMiddle = Math.floor((sortedValues.length - 1) / 2);
            const highMiddle = Math.ceil((sortedValues.length - 1) / 2);
            const median =
              (sortedValues[lowMiddle] + sortedValues[highMiddle]) / 2;
            this.compsTableData.columnData[colKey].median[valueType] = median;
            this.compsTableData.columnData[colKey].median["currency"] =
              currency;
          } else {
            this.compsTableData.columnData[colKey].median[valueType] = null;
          }
        }
      });
    });
  }

  computeTotal() {
    const valueForCalculation = this.showRevision ? "revision" : "values"; // We need revision or values data to calculate average
    const totalValuesArr = [];

    // period/line calculation
    this.compsTableData.columns.forEach((colKey, index) => {
      const colSliId = this.isTimeSeries
        ? this.compsTableData.columnData[colKey].sliCompsId
        : colKey;
      const period = this.isTimeSeries ? colKey : this.selectedPeriod;
      const canLineIdBeTotaled = this.isTimeSeries
        ? this.lineHasTotal
        : this.compsTableData.columnData[colKey].totaled;
      if (
        (this.currency === "Base" &&
          this.compsTableData.columnData[colKey].unit === "Amount") ||
        !canLineIdBeTotaled
      ) {
        this.compsTableData.columnData[colKey].total = {};
      } else {
        const values: Array<number> = [];
        let currency = "";
        this.compsTableData.rows.forEach((row) => {
          if (
            this.compsTableData.rowData[row.ticker] &&
            this.compsTableData.rowData[row.ticker][colSliId] &&
            this.compsTableData.rowData[row.ticker][colSliId][period] &&
            this.compsTableData.rowData[row.ticker][colSliId][period][
              valueForCalculation
            ] !== undefined &&
            this.compsTableData.rowData[row.ticker][colSliId][period][
              valueForCalculation
            ] !== "NM" &&
            (this.showBlankTickers ||
              (!this.showBlankTickers &&
                this.compsTableData.rowData[row.ticker][
                  `${colSliId}|data_exists`
                ]))
          ) {
            values.push(
              this.compsTableData.rowData[row.ticker][colSliId][period][
                valueForCalculation
              ],
            );
            currency = this.compsTableData.rowData[row.ticker][`${colSliId}|C`];
          }
        });
        if (values.length) {
          const summation = values.reduce((sum, val) => sum + val);
          totalValuesArr.push(summation);
          if (this.showYoy) {
            // Calculate only if we have previous year value
            let yoyTotal = null;
            if (totalValuesArr[index - 1] !== undefined) {
              yoyTotal = getYoy(
                totalValuesArr[index - 1],
                totalValuesArr[index],
              );
            }
            // Set total value of yoy
            this.compsTableData.columnData[colKey].total.yoy = yoyTotal;
          }
          // Set total value of value or revision
          this.compsTableData.columnData[colKey].total[valueForCalculation] =
            summation;
          this.compsTableData.columnData[colKey].total["currency"] = currency;
        } else {
          totalValuesArr.push(undefined);
          this.compsTableData.columnData[colKey].total = {};
        }
      }
    });
  }

  computeCompanyCount() {
    const viewBy = [];
    if (this.showValue) {
      viewBy.push("values");
    }
    if (this.showYoy) {
      viewBy.push("yoy");
    }
    if (this.showRevision) {
      viewBy.push("revision");
    }
    // period/line Columns calculation

    this.compsTableData.columns.forEach((colKey) => {
      let companyCount = 0;
      const colSliId = this.isTimeSeries
        ? this.compsTableData.columnData[colKey].sliCompsId
        : colKey;
      const period = this.isTimeSeries ? colKey : this.selectedPeriod;
      viewBy.forEach((valueType) => {
        this.compsTableData.rows.forEach((row) => {
          if (
            this.compsTableData.rowData[row.ticker] &&
            this.compsTableData.rowData[row.ticker][colSliId] &&
            this.compsTableData.rowData[row.ticker][colSliId][period] &&
            this.compsTableData.rowData[row.ticker][colSliId][period][
              valueType
            ] !== undefined &&
            this.compsTableData.rowData[row.ticker][colSliId][period][
              valueType
            ] !== "NM" &&
            (this.showBlankTickers ||
              (!this.showBlankTickers &&
                this.compsTableData.rowData[row.ticker][
                  `${colSliId}|data_exists`
                ]))
          ) {
            companyCount += 1;
          }
        });
        this.compsTableData.columnData[colKey].tickerCount[valueType] =
          companyCount || 0;
      });
    });
  }

  showFormulaBar() {
    this.store.dispatch(new SetAuditCallFbar({ expanded: true }));
  }

  showChartPopup(item: Dictionary<any>, chartType: string) {
    this.onShowChart.emit({ item: item, chartType: chartType });
  }

  navigateToDedicatedPage(item: Dictionary<any>, chartType: string) {
    const periodType = this.compsTableData.filter.periodType;
    const isOtherPeriod =
      item.period === "NTM" || item.period === "LTM" || item.period === "STM";
    let url = `/charts/current?ticker=${item.row.ticker}&lineId=${
      item.dapParamId
    }&chartTypeId=${chartType === "trend" ? 2 : 3}`;

    if (isOtherPeriod) {
      url += `&other_period=${item.period}&is_annual_selected=${false}`;
    } else {
      url += `&periods=${item.period}&is_annual_selected=${true}&period_type=${periodType}`;
    }

    window.open(url, "_blank");
  }

  dismissSnackBar() {
    if (this.snackBarRef) {
      this.snackBarRef.dismiss();
    }
  }

  deleteTicker(row: CompsTableRow) {
    if (this.compsTableData.rows.length === 1) {
      this.message.error("Error: Cannot remove all the rows.");
      return;
    }

    //Check with Naina
    // this.route &&
    //   this.route.params.subscribe(() => {
    //     if (this.tickerDelete) {
    //       this.snackBarRef.dismiss();
    //       this.selectedLineCell = "";
    //       this.onDeleteTicker.emit({
    //         sliCompId: row.sli_comps_id,
    //         ticker: row.ticker
    //       });
    //       this.tickerDelete = false;
    //     }
    //   });
    // this.tickerDelete = true;
    // this.onChangeTicker.emit(true);

    const rowIndex = this.compsTableData.rows.findIndex(
      (r: CompsTableRow) => r.ticker === row.ticker,
    );
    if (rowIndex !== -1) {
      this.compsTableData.rows.splice(rowIndex, 1);
      if (this.showAverage) {
        this.computeAverages();
      }
      if (this.showMedian) {
        this.computeMedians();
      }
      // if (this.showTotal) {
      //   this.computeTotal();
      // }
      if (this.showCompanyCount) {
        this.computeCompanyCount();
      }
      this.table.renderRows();

      this.snackbarMessage = `Company ${row.ticker} is removed`;
      this.snackBarRef = this.snackBar.openFromTemplate(this.successTemplate, {
        panelClass: "success",
        duration: 5000,
        verticalPosition: "top",
      });
      this.selectedLineCell = "";
      this.onDeleteTicker.emit({
        sliCompId: row.sli_comps_id,
        ticker: row.ticker,
      });
      const urlArr = window.location.href.split("/");
      this.appService.logUserAction(
        {},
        "",
        "",
        "COMPS_TICKER_DELETE",
        {
          sli_comps_id: [row.sli_comps_id],
          tab_id: urlArr[urlArr.length - 1],
          is_row: true,
          ticker: row.ticker,
        },
        "",
        "COMPS_PAGE",
      );
      // this.snackBarRef.afterDismissed().subscribe((reason) => {
      //   if (reason.dismissedByAction) {
      //     this.tickerDelete = false;
      //     this.compsTableData.rows.splice(rowIndex, 0, row);
      //     this.computeAverages();
      //     this.computeMedians();
      //     // Material table bug. Is shows empty row if timeout is not added
      //     setTimeout(() => {
      //       this.table.renderRows();
      //     }, 10);
      //     this.onDeleteTicker.emit({
      //       isSnackbar: false
      //     });
      //     this.appService.logUserAction(
      //       {},
      //       "",
      //       "",
      //       "COMPS_UNDO_TICKER_DELETE",
      //       {
      //         sli_comps_id: row.sli_comps_id,
      //         tab_id: urlArr[urlArr.length - 1],
      //         ticker: row.ticker
      //       },
      //       "",
      //       "COMPS_PAGE"
      //     );
      //   } else {
      //     this.selectedLineCell = "";
      //     this.onDeleteTicker.emit({
      //       sliCompId: row.sli_comps_id,
      //       ticker: row.ticker
      //     });
      //     this.tickerDelete = false;
      //   }
      //   this.onDeleteTicker.emit({
      //     isSnackbar: false
      //   });
      // });
    }
    event.stopPropagation(); //Prevent row selection
  }

  checkIfMarketKey(key) {
    return Number(key) === 10 || Number(key) === 11 || Number(key) === 34;
  }
}
